import React from "react";
import {
  FaCalendarAlt,
  FaHistory,
  FaInfoCircle,
  FaNewspaper,
  FaUsers,
} from "react-icons/fa";
import "./Home.css";
import PhotoGrid from "./PhotoGrid";

import heroBike from "../../assets/matchlessg3wo.jpeg";
import clubLogo from "../../assets/secion_badge-Photoroom.png";
import roadSign from "../../assets/roadsign.png";
import meetFingleOne from "../../assets/meet1.jpeg";
import meetFingleTwo from "../../assets/meet2.jpeg";
import meetFingleThree from "../../assets/meet3.jpeg";
import meetPrincetownOne from "../../assets/princetown_nov.png";
import meetPrincetownTwo from "../../assets/pricentown_nov2.jpeg";
import meetTwoBridgesOne from "../../assets/twobridges1.jpeg";
import meetTwoBridgesTwo from "../../assets/twobridges2.jpeg";
import mountKelly from "../../assets/mtkelly.jpg";
import rallyPlanningBadge from "../../assets/rallyBadge.png";
import jampotPublicEvening from "../../assets/jampot-public-evening-2026.jpg";
import widemouthRideout from "../../assets/widemouth-bay-rideout-2026.png";
import kitHill from "../../assets/kithill.jpg";

const upcomingEvents = [
  {
    title: "Rally Planning Meeting",
    date: "Saturday 18th July 2026 - 2:00 PM",
    location: "Plymouth",
    logo: rallyPlanningBadge,
  },
  {
    title: "Classic Motorcycle Summer Evening",
    date: "Saturday 15th August 2026 - From 7:00 PM",
    location: "Mount Kelly, Tavistock",
    image: jampotPublicEvening,
  },
  {
    title: "Jampot Rally",
    date: "14th to 17th August 2026",
    location: "Tavistock",
    logo: rallyPlanningBadge,
  },
];

const latestNews = [
  {
    title: "Saturday Ride-Out Trial Run",
    date: "30th May 2026",
    summary:
      "Recent trial run of the Saturday ride out for the Jampot Rally, to Widemouth Bay. James, Tim, Derry and Andrew rode the 84 mile route to test it out.",
    image: widemouthRideout,
  },
  {
    title: "Jampot Rally Planning",
    date: "28th February 2026",
    summary:
      "Rally planning continued in Plymouth, covering ride-out routes, meal plans, bands, and the final shape of the weekend programme.",
    image: rallyPlanningBadge,
  },
];

const galleryImages = [
  widemouthRideout,
  meetFingleOne,
  meetFingleTwo,
  meetPrincetownOne,
  meetTwoBridgesOne,
  mountKelly,
];

const previousEvents = [
  {
    title: "Saturday 20th June 2026 - Club Meetup at Kit Hill",
    description:
      "Section meetup at Kit Hill Country Park, meeting at Louis Tea Room.",
    photos: [{ image: kitHill, subtitle: "" }],
  },
  {
    title: "Saturday 30th May 2026 - Jampot Rally Saturday Ride-Out Trial Run",
    description:
      "James, Derry, Andrew and Tim completed the 84 mile trial run of the Jampot Rally Saturday ride out, travelling to Widemouth Bay and Davidstow War Museum.",
    photos: [{ image: widemouthRideout, subtitle: "" }],
  },
  {
    title: "28th February - Plymouth Rally Planning Meeting",
    description:
      "Second rally planning meeting in Plymouth to firm up details for Jampot Rally 2026 - ride-out routes, meal plans, bands, and the final shape of the weekend programme.",
    photos: [{ image: rallyPlanningBadge, subtitle: "" }],
  },
  {
    title: "31st January - Plymouth Rally Planning Meeting",
    description:
      "Rally planning meeting in Plymouth to work through the next steps for Jampot Rally 2026 - including ride-outs, catering options, entertainment, and site logistics.",
    photos: [{ image: rallyPlanningBadge, subtitle: "" }],
  },
  {
    title: "December 11 - Jampot Rally Planning",
    description:
      "Tim, Derry, and James met up with Josh and Andrew at Mount Kelly - the venue for the 2026 Jampot Rally - to discuss the site and its facilities. It looks like a fantastic place to host the rally, with everything needed for the weekend.",
    photos: [{ image: mountKelly, subtitle: "" }],
  },
  {
    title: "October - Section Meet at Princetown",
    description:
      "James, Andrew, Tim, Graham, Derry and bikes parked outside the Plume of Feathers in Princetown, on Dartmoor. The group discussed venues and plans for the 2026 Jampot Rally.",
    photos: [
      { image: meetPrincetownOne, subtitle: "" },
      { image: meetPrincetownTwo, subtitle: "" },
    ],
  },
  {
    title: "May - Section Meet and Ride Out to Two Bridges",
    description:
      "Alan, Derry and bikes parked on one of the two bridges after a ride across Dartmoor. Around 10 members met at Whiddon Down and rode across Dartmoor to the pub at Two Bridges.",
    photos: [
      { image: meetTwoBridgesOne, subtitle: "" },
      { image: meetTwoBridgesTwo, subtitle: "" },
    ],
  },
  {
    title: "March - Section Meet at Fingle Bridge",
    description:
      "Andrew, Malcolm, Tony, James and bikes met up at the pub for lunch, taking advantage of the good weather to ride there.",
    photos: [
      { image: meetFingleOne, subtitle: "" },
      { image: meetFingleTwo, subtitle: "" },
      { image: meetFingleThree, subtitle: "" },
    ],
  },
  {
    title: "November 2024 - First Section Meet at Belstone",
    description:
      "The first ever section meet up - only four members, but it was the first one, and it was November.",
    photos: [],
  },
  {
    title: "August 2024 - Devon and Cornwall Section Formed",
    description:
      "The main club approved the formation of the new Devon and Cornwall Section.",
    photos: [],
  },
];

function Home({ onNavigate }) {
  const handleRallyBannerClick = (event) => {
    if (!onNavigate) return;

    event.preventDefault();
    onNavigate("jampot");
  };

  return (
    <main className="home-vintage">
      <div className="home-vintage__frame">
        <section className="home-vintage__hero">
          <div className="home-vintage__hero-art">
            <img src={heroBike} alt="Matchless G3WO motorcycle on the Devon coast" />
          </div>

          <div className="home-vintage__hero-copy">
            <p className="home-vintage__eyebrow">Devon &amp; Cornwall Section</p>
            <h1>AJS &amp; Matchless</h1>
            <p className="home-vintage__owners">Owners Club</p>
            <p className="home-vintage__intro">
              Ride-outs, rallies, technical support and social events for AJS and
              Matchless enthusiasts across Devon and Cornwall.
            </p>
          </div>
        </section>

        <a
          className="home-vintage__rally-banner"
          href="#/jampot"
          onClick={handleRallyBannerClick}
          aria-label="View the 2026 Jampot Rally page"
        >
          <img src={rallyPlanningBadge} alt="" aria-hidden="true" />
          <div className="home-vintage__rally-title">
            <h2>2026 Jampot Rally</h2>
            <p>14th - 17th August 2026 - Tavistock, Devon</p>
          </div>
          <p className="home-vintage__rally-copy">
            The club's annual rally set in the heart of West Devon. Four days of great roads,
            good company and classic motorcycles.
          </p>
        </a>

        <section
          className="home-vintage__public-event"
          aria-labelledby="home-public-event-title"
        >
          <div className="home-vintage__public-event-poster">
            <img
              src={jampotPublicEvening}
              alt="Classic Motorcycle Summer Evening poster for Saturday 15th August from 7pm at Mount Kelly, Tavistock, with live band, outdoor bar and classic bike display."
              loading="lazy"
            />
          </div>

          <div className="home-vintage__public-event-copy">
            <p className="home-vintage__public-event-kicker">Public Event</p>
            <h2 id="home-public-event-title">Classic Motorcycle Summer Evening</h2>
            <p className="home-vintage__public-event-lede">
              Everyone is welcome to join us at Mount Kelly on Saturday 15th August
              2026 from 7pm for a relaxed summer evening of live music, classic
              motorcycles and good company.
            </p>

            <dl className="home-vintage__public-event-details">
              <div>
                <dt>When</dt>
                <dd>Saturday 15th August 2026, from 7pm</dd>
              </div>
              <div>
                <dt>Where</dt>
                <dd>Mount Kelly, Tavistock</dd>
              </div>
            </dl>

            <div className="home-vintage__public-event-highlights" aria-label="Event highlights">
              <span>Live band</span>
              <span>Outdoor bar</span>
              <span>Classic bike display</span>
            </div>
          </div>
        </section>

        <section className="home-vintage__panel-grid">
          <article className="home-vintage__panel">
            <div className="home-vintage__panel-heading">
              <FaCalendarAlt />
              <h2>Upcoming Events</h2>
            </div>

            <div className="home-vintage__event-list">
              {upcomingEvents.map((event) => (
                <div key={event.title} className="home-vintage__event-item">
                  {event.image || event.logo ? (
                    <img
                      src={event.image || event.logo}
                      alt=""
                      aria-hidden="true"
                      className={
                        event.image
                          ? "home-vintage__event-photo"
                          : "home-vintage__event-logo"
                      }
                    />
                  ) : (
                    <span className="home-vintage__event-dot" aria-hidden="true" />
                  )}
                  <div>
                    <h3>{event.title}</h3>
                    <p>{event.date}</p>
                    <p>{event.location}</p>
                    {event.url && (
                      <a href={event.url} target="_blank" rel="noreferrer">
                        Event details
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </article>

          <article className="home-vintage__panel">
            <div className="home-vintage__panel-heading">
              <FaNewspaper />
              <h2>Latest News</h2>
            </div>

            <div className="home-vintage__news-list">
              {latestNews.map((item) => (
                <div key={item.title} className="home-vintage__news-item">
                  <img src={item.image} alt="" aria-hidden="true" />
                  <div>
                    <h3>{item.title}</h3>
                    <p className="home-vintage__news-date">{item.date}</p>
                    <p>{item.summary}</p>
                  </div>
                </div>
              ))}
            </div>
          </article>

          <article className="home-vintage__panel home-vintage__about-panel">
            <div className="home-vintage__panel-heading">
              <FaInfoCircle />
              <h2>About Our Section</h2>
            </div>

            <p className="home-vintage__about-copy">
              We are a friendly group of Matchless and AJS enthusiasts covering Devon
              and Cornwall. Our section organises ride-outs and social events, and this year the Jampot Rally.
            </p>
            <img
              className="home-vintage__about-image"
              src={roadSign}
              alt=""
              aria-hidden="true"
            />
          </article>
        </section>

        <section className="home-vintage__welcome">
          <FaUsers aria-hidden="true" />
          <div>
            <h2>New Members and Non-Members Always Welcome</h2>
            <p>
              Whether you ride an AJS, Matchless or simply have an interest in these
              classic machines, you will find a warm welcome.
            </p>
          </div>
        </section>

        <section className="home-vintage__photo-strip" aria-label="Section photos">
          {galleryImages.map((image, index) => (
            <img key={image} src={image} alt="" aria-hidden="true" loading="lazy" />
          ))}
        </section>

        <section className="home-vintage__timeline">
          <div className="home-vintage__timeline-heading">
            <FaHistory />
            <div>
              <p className="home-vintage__timeline-kicker">Section Archive</p>
              <h2>Previous Events</h2>
            </div>
          </div>

          <div className="home-vintage__timeline-list">
            {previousEvents.map((event) => (
              <article key={event.title} className="home-vintage__timeline-card">
                <div className="home-vintage__timeline-marker" aria-hidden="true" />
                <div className="home-vintage__timeline-content">
                  <p className="home-vintage__timeline-meta">
                    Devon &amp; Cornwall Section
                  </p>
                  <h3>{event.title}</h3>
                  <p>{event.description}</p>
                  {event.photos.length > 0 && <PhotoGrid photos={event.photos} />}
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="home-vintage__footer-card">
          <img src={clubLogo} alt="AJS and Matchless owners club crest" />
          <div>
            <h2>AJS &amp; Matchless Owners Club</h2>
            <p>Devon &amp; Cornwall Section</p>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Home;
